import css from 'styled-jsx/css';
import { sansSerif } from 'styles/css-constants';
import { warmGrays } from 'styles/colors/constants';
import { MQ_LARGE } from 'constants/mq';

export default css`
  .Post__tag {
    display: flex;
  }

  .Post__tag::before {
    content: '';
    margin: 0.25rem 0;
    width: 0;
    border-left: 1px solid ${warmGrays[6]};
  }

  .Post__tag-link {
    margin: 0;
    display: block;
    border: none;
    padding: 0.25rem 0.375rem;
    color: ${warmGrays[6]};
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg2);
    font-weight: 400;
    letter-spacing: 0.05em;
    text-decoration: none;
    text-transform: uppercase;
  }

  @media screen and ${MQ_LARGE} {
    .Post__tag-link {
      font-size: var(--fontScaleNeg1);
    }
  }
`;
